<template>
  <el-card shadow="never" v-loading="Polygonloading">
    <el-tabs v-model="activeMapName" @tab-click="getfirstPath">
      <el-tab-pane :label="$t('operate.name74')" name="first">
        <template>
          <baidu-map class="bm-view" :center="baiduMapCenter" :zoom="16"
                     :scroll-wheel-zoom="true"  @ready="handleMap" @click="handleMapClick">
            <bm-marker :position="{lng:item.lng, lat: item.lat}" v-for="(item,index) in polygonPath"
                       :key="index"
                       :icon="iconpoint" :offset="{width: 20, height: -10}">
              <bm-label :content=item.name :labelStyle="{color: 'red', fontSize : '12px'}"
                        :offset="{width: 30, height:10}"/>
            </bm-marker>
            <bm-polygon :path="polygonPath" stroke-color="blue" :stroke-opacity="0.5"
                        :stroke-weight="2" :editing="true"
                        @lineupdate="updatePolygonPath" @mouseover="mouseoverpath" @mouseout="mouseoutpath"/>
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
            <bm-auto-complete v-model="addressKeyword" :sugStyle="{zIndex: 999999}">
            <el-input v-model="addressKeyword" :placeholder="$t('public.name5')" class="serachinput"></el-input>
          </bm-auto-complete>
          <bm-local-search :keyword="addressKeyword" :pageCapacity="2" :panel="isShowPanel" :auto-viewport="true" :selectFirstResult="true"  @searchcomplete="searchcomplete" style="width:0px;height:0px;overflow: hidden;"></bm-local-search>
          </baidu-map>
        </template>
        <template>
          <el-table
            :data="polygonPath"
            style="width: 100%">
            <el-table-column
              prop="name"
              :label="$t('screen.name169')"
              width="180">
            </el-table-column>
            <el-table-column
              prop="lng"
              :label="$t('screen.name170')"
              width="180">
              <template slot-scope="scope">
            <span v-if="scope.row.edit === true">
              <el-input size="small" v-model="scope.row.lng">
                <span>{{ scope.row.lng }}</span>
              </el-input>
            </span>
                <span v-else>{{ scope.row.lng }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="lat"
              width="180"
              :label="$t('screen.name171')">
              <template slot-scope="scope">
            <span v-if="scope.row.edit === true">
              <el-input size="small" v-model="scope.row.lat">
                <span>{{ scope.row.lat }}</span>
              </el-input>
            </span>
                <span v-else>{{ scope.row.lat }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('screen.name110')" width="220px">
              <template slot-scope="scope">
            <span v-if="scope.row.edit === false">
               <el-button type="warning" size="mini" @click="editPolygonPath(scope.row)">
              {{ $t('screen.name111') }}
            </el-button>
               <el-button type="danger" size="mini" @click="deletePolygonPath(scope)">{{
                   $t('screen.name112')
                 }}</el-button>
                  <el-button type="primary" size="mini" @click="locationPoints(scope.row)">{{
                   $t('screen.name1')
                 }}</el-button>
            </span>
                <span v-else>
               <el-button type="primary" size="mini" @click="savePolygonPath(scope.row)">{{
                   $t('screen.name168')
                 }}</el-button>
              <el-button type="warning" size="mini" @click="firstdeletePolygonPath(scope)">{{
                  $t('screen.name79')
                }}</el-button>
            </span>
              </template>
            </el-table-column>
          </el-table>
          <template>
            <div style="margin-top: 20px">
              <el-button type="success" size="mini" @click="addPolygonPath()">{{ $t('screen.name95') }}</el-button>
              <el-button type="primary" size="mini" @click="uploadPolygonPath()">{{ $t('screen.name172') }}</el-button>
            </div>
          </template>
        </template>
      </el-tab-pane>
      <el-tab-pane :label="$t('operate.name73')" name="second">
        <template>
          <div class="content">
            <div :style="googleMapStyle" class="googleMap" :id="mapID"></div>
          </div>
        </template>
        <template>
          <el-table
            :data="mapPath"
            style="width: 100%">
            <el-table-column
              prop="name"
              :label="$t('screen.name169')"
              width="180">
            </el-table-column>
            <el-table-column
              prop="lng"
              :label="$t('screen.name170')"
              width="180">
              <template slot-scope="scope">
            <span v-if="scope.row.edit === true">
              <el-input size="small" v-model="scope.row.lng">
                <span>{{ scope.row.lng }}</span>
              </el-input>
            </span>
                <span v-else>{{ scope.row.lng }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="lat"
              width="180"
              :label="$t('screen.name171')">
              <template slot-scope="scope">
            <span v-if="scope.row.edit === true">
              <el-input size="small" v-model="scope.row.lat">
                <span>{{ scope.row.lat }}</span>
              </el-input>
            </span>
                <span v-else>{{ scope.row.lat }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('screen.name110')" width="150px">
              <template slot-scope="scope">
                <el-button type="danger" size="mini"
                           @click="deletePolygonPathgoogle(scope)">{{ $t('screen.name112') }}
                </el-button>
                <el-button type="primary" size="mini" @click="locationPoints(scope.row)">{{
                   $t('screen.name1')
                 }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <template>
            <div style="margin-top: 20px">
              <!--          <el-button type="success" size="mini" @click="addPolygonPath()">{{ $t('screen.name230') }}</el-button>-->
              <el-button type="primary" size="mini" @click="uploadPolygonPathgoogle()">{{
                  $t('screen.name172')
                }}
              </el-button>
            </div>
          </template>
        </template>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>
<script>
import coordtransform from 'coordtransform'
import { Loader } from '@googlemaps/js-api-loader' // 引入
import { findFenceDetail, modifyFence } from '@/api/operate.js'
import { escapeHtml } from '@/utils/htmlEscape'
export default {
  props: {
    // obj: {
    //   type: Object,
    //   required: false
    // },
    fenceId: {
      type: String,
      default: ''
    }
  },
  watch: {
    // obj: {
    //   handler: function (n, o) {
    //     if (n.dialogCycleTraceVisible === true) {
    //       this.fenceIdinfo = n.fenceId
    //       this.getfirstPath()
    //     }
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  components: {
  },
  data () {
    return {
      map: null,
      BMap: null,
      longitude: '',
      latitude: '',
      address: '',
      isShowPanel: true,
      infoWindowShow: false,
      addressKeyword: '',
      // 地图切换
      activeMapName: 'first',
      baiduMapCenter: { lng: '119.068917', lat: '31.672315' },
      // 详情、修改围栏
      polygonPath: [],
      editRegionFrom: {
        fenceName: '',
        fenceType: '',
        regionId: '',
        fencePointList: []
      },
      fenceIdinfo: '',
      iconpoint: {
        url: require('@/assets/point.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      iconpointgoogle: {
        url: require('@/assets/point.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      polygonPathgooglepolygonPath: [],
      Polygonloading: true,
      pointnew: false,
      polygonPathpush: [],
      // 谷歌地图样式
      polygonPathgoogle: [],
      polygonPathgooglepush: [],
      mapID: 'googleMap',
      mapType: 'POLYGON',
      googleMapStyle: {
        wdith: '100%',
        height: '500px'
      },
      mapOptions: {
        // 为了关闭默认控件集,设置地图的disableDefaultUI的属性为true
        disableDefaultUI: false,
        // 启用缩放和平移
        gestureHandling: 'greedy',
        panControl: true,
        zoomControl: true,
        scaleControl: true,
        // 关闭街景
        streetViewControl: false
      },
      // 谷歌地图缩放级别
      zoom: 16,
      // 谷歌地图中心点
      googleMapCenter: {
        lng: 119.068917,
        lat: 31.672315
      },
      // 谷歌地图图形path
      mapPath: [],
      markers: [],
      // 地图选点回显值
      longlat: '',
      // 标记点
      marker: [],
      // 图标实例
      markerBlack: [],
      // 图形实例
      graphicalExample: null,
      // 图形路径经纬度
      graphicalPath: [],
      apiKey: 'AIzaSyBQZEsRZwha4KWyKHD-TfZ9wOnzmwxXmz4',
      as: [],
      infoWindow: {
        info: {}
      }
    }
  },
  created () {
    this.$nextTick(() => {
      const loader = new Loader({
        apiKey: this.apiKey, // 之前的key
        version: 'weekly', // 版本
        libraries: ['places', 'drawing'], // 插件库places为基础库 drawing为绘制工具库
        region: 'Canada',
        language: 'en'
      })
      const mapOptions = {
        center: {
          lat: this.googleMapCenter.lat * 1,
          lng: this.googleMapCenter.lng * 1
        }, // 中心点
        zoom: this.zoom, // 缩放级别
        ...this.mapOptions // 其他配置
      }
      loader
        .load()
        .then((google) => {
          const map = new google.maps.Map(document.getElementById(this.mapID), mapOptions)
          this.googleMap = map
          this.googleApi = google
          // console.log(this.googleMap, '谷歌地图实例')
          // console.log(this.googleApi, '谷歌地图api')
          if (this.mapType === 'selectPoint') {
            this.selectPoint()
            this.addDraggableMarkers(1, true, this.googleMapCenter)
          }
          if (this.mapType === 'POLYGON') {
            // 中心点
            this.addDraggableMarkers(1, false, this.googleMapCenter)
            // 如果是绘制图形类型则开始实例化绘制工具库
            const drawingModesList = {
              MARKER: this.googleApi.maps.drawing.OverlayType.MARKER,
              CIRCLE: this.googleApi.maps.drawing.OverlayType.CIRCLE,
              POLYGON: this.googleApi.maps.drawing.OverlayType.POLYGON,
              POLYLINE: this.googleApi.maps.drawing.OverlayType.POLYLINE,
              RECTANGLE: this.googleApi.maps.drawing.OverlayType.RECTANGLE
            }
            const drawingManager = new this.googleApi.maps.drawing.DrawingManager({
              drawingControl: true,
              drawingControlOptions: {
                position: this.googleApi.maps.ControlPosition.TOP_CENTER,
                drawingModes: [drawingModesList[this.mapType]]
              },
              polygonOptions: {
                fillColor: 'blue',
                strokeColor: 'blue',
                strokeOpacity: 0.8,
                fillOpacity: 0.4,
                strokeWeight: 5,
                clickable: false,
                editable: true,
                zIndex: 1
              }
            })
            drawingManager.setMap(map)
            // 监听绘制多边形完成事件事件
            this.googleApi.maps.event.addListener(drawingManager, 'polygoncomplete', (e) => {
              // 存在就清除上一个图形
              if (this.graphicalExample) {
                this.graphicalExample.setMap(null)
              }
              // path路径emit传出
              // console.log(e.getPath().Eg)
              this.setPath(e.getPath().Eg)
              this.graphicalExample = e
              // 监听回显图形每一个路径点
              this.googleApi.maps.event.addListener(e.getPath(), 'insert_at', (event) => {
                // path路径emit传出
                this.setPath(e.getPath().Eg)
              })
              this.googleApi.maps.event.addListener(e.getPath(), 'set_at', (event) => {
                this.setPath(e.getPath().Eg)
              })
              // 绘制完成后关闭绘制状态
              drawingManager.setDrawingMode(null)
            })
            // 回显图形
            // this.queryInfobill = this.$options.data().queryInfobill
            // if (JSON.parse(this.mapPath).length > 0) {
            // if (this.mapPath.length > 0) {
            //   this.echoGraphical()
            // }
          }
        })
        .catch((e) => {
          // do something
          console.log(e)
        })
    })
  },
  computed: {},
  mounted() {
  },
  methods: {
    searchcomplete(results) {
      this.isShowPanel = true
      if (results) {
        this.as = results.Rr
        console.log('this.as====', this.as)
      }
    },
    handleMapClick(item) {
      console.log('item====', item)
      this.latitude = item.point.lat
      this.longitude = item.point.lng
      // var content = '<table>'
      // content = content + '<tr><td> 经纬度：' + this.longitude + ' , ' + this.latitude + '</td></tr>'
      // content += '</table>'
      // var infowindow = new this.BMap.InfoWindow(content)
      // var point = new this.BMap.Point(this.longitude, this.latitude)
      // this.map.openInfoWindow(infowindow, point)
      // const pt = new this.BMap.Point(this.longitude, this.latitude)
      const geoc = new this.BMap.Geocoder()
      geoc.getLocation(item.point, (rs) => {
        console.log('rs=====', rs)
        if (rs.surroundingPois.length) {
          this.address = rs.surroundingPois[0].address
          this.latitude = rs.surroundingPois[0].point.lat
          this.longitude = rs.surroundingPois[0].point.lng
        } else {
          this.address = rs.address
          this.latitude = rs.point.lat
          this.longitude = rs.point.lng
        }
        var content = '<table>'
        content = content + '<tr><td> ' + this.$t('screen.name13') + escapeHtml(this.address) + '</td></tr>'
        content = content + '<tr><td> ' + this.$t('bike.name87') + escapeHtml(this.longitude) + ' , ' + escapeHtml(this.latitude) + '</td></tr>'
        content += '</table>'
        var infowindow = new this.BMap.InfoWindow(content)
        var point = new this.BMap.Point(this.longitude, this.latitude)
        this.map.openInfoWindow(infowindow, point)
      })
    },
    handleMap({ BMap, map }) {
      this.map = map
      this.BMap = BMap
      this.getfirstPath()
    },
    infoWindowClose() {
      this.latitude = ''
      this.longitude = ''
      this.infoWindowShow = false
    },
    async getfirstPath() {
      this.Polygonloading = true
      this.pointnew = false
      const res = await findFenceDetail({ fenceId: this.fenceId })
      this.editRegionFrom = res.data.fence
      if (this.activeMapName === 'first') {
        // this.Polygonloading = false
        this.baidumapsetmaps()
      } else if (this.activeMapName === 'second') {
        this.googlemapstemasps()
      }
    },
    // 百度处理坐标
    baidumapsetmaps () {
      this.polygonPath = this.editRegionFrom.fencePointList
      if (this.polygonPath.length) {
        this.baiduMapCenter = { lng: this.polygonPath[0].lng, lat: this.polygonPath[0].lat }
      }
      this.polygonPath.forEach((list, index) => {
        const bikepointbaidu = coordtransform.wgs84togcj02(list.lng, list.lat)
        const bikepointsbaidu = coordtransform.gcj02tobd09(bikepointbaidu[0], bikepointbaidu[1])
        list.lng = Number(bikepointsbaidu[0])
        list.lat = Number(bikepointsbaidu[1])
      })
      setTimeout(() => {
        this.getPolygonPath()
        this.Polygonloading = false
      }, 1000)
    },
    // 谷歌处理坐标
    googlemapstemasps () {
      this.polygonPathgoogle = this.editRegionFrom.fencePointList
      this.polygonPathgoogle.forEach((list, index) => {
        const bikepoint = coordtransform.wgs84togcj02(list.lng, list.lat)
        list.lng = Number(bikepoint[0])
        list.lat = Number(bikepoint[1])
      })
      this.mapPath = this.polygonPathgoogle
      // this.googleMapCenter = {
      //   lng: this.mapPath[0].lng,
      //   lat: this.mapPath[0].lat
      // },
      this.googleMap.setCenter({ lng: this.mapPath[0].lng, lat: this.mapPath[0].lat })
      setTimeout(() => {
        this.echoGraphical()
        this.Polygonloading = false
      }, 1000)
    },
    getgooglePolygonPath () {
      const poiylist = []
      this.mapPath.forEach((list, index) => {
        poiylist.push({
          name: this.$t('screen.name169') + (index + 1),
          serialNo: index + 1,
          edit: false,
          index: index + 1,
          lng: list.lng,
          lat: list.lat
        })
      })
      this.mapPath = poiylist
    },
    getPolygonPath () {
      const poiylist = []
      this.polygonPath.forEach((list, index) => {
        poiylist.push({
          name: this.$t('screen.name169') + (index + 1),
          serialNo: index + 1,
          edit: false,
          index: index + 1,
          lng: list.lng,
          lat: list.lat
        })
      })
      this.polygonPath = poiylist
    },
    updatePolygonPath (e) {
      this.polygonPath = e.target.getPath()
      const poiylist = []
      this.polygonPath.forEach((list, index) => {
        poiylist.push({
          name: this.$t('screen.name169') + (index + 1),
          edit: false,
          serialNo: index + 1,
          index: index + 1,
          lng: list.lng,
          lat: list.lat
        })
      })
      this.polygonPath = poiylist
    },
    editPolygonPath (item) {
      if (this.pointnew === false) {
        this.pointnew = true
        item.edit = true
      } else {
        this.$message.error(this.$t('screen.name173'))
      }
    },
    locationPoints(item) {
      if (this.activeMapName === 'first') {
        this.baiduMapCenter = { lng: item.lng, lat: item.lat }
      } else {
        this.googleMap.setCenter({ lng: item.lng, lat: item.lat })
      }
    },
    savePolygonPath (item) {
      item.edit = false
      this.pointnew = false
      this.getPolygonPath()
    },
    deletePolygonPath (index) {
      this.polygonPath.splice(index.$index, 1)
    },
    deletePolygonPathgoogle (index) {
      this.mapPath.splice(index.$index, 1)
      // this.mapPath = this.polygonPathgoogle
      this.echoGraphical()
    },
    firstdeletePolygonPath (index) {
      this.pointnew = false
      this.polygonPath.splice(index.$index, 1)
    },
    mouseoutpath () {
    },
    mouseoverpath () {
    },
    addPolygonPath () {
      if (this.pointnew === false) {
        this.pointnew = true
        this.polygonPath.push({
          name: this.$t('screen.name174'),
          edit: true,
          lng: '',
          lat: ''
        })
      } else {
        this.$message.error(this.$t('screen.name175'))
      }
    },
    // 谷歌
    async uploadPolygonPathgoogle () {
      this.polygonPathpush = JSON.parse(JSON.stringify(this.mapPath))
      this.polygonPathpush.forEach((list, index) => {
        const bikepoints = coordtransform.gcj02towgs84(list.lng, list.lat)
        list.lng = Number(bikepoints[0])
        list.lat = Number(bikepoints[1])
        this.polygonPathgooglepush.push(list)
      })
      const polygonPathpush = []
      this.polygonPathgooglepush.map((item, index) => {
        polygonPathpush.push({
          lat: item.lat,
          lng: item.lng,
          edit: item.edit,
          name: item.name,
          serialNo: index + 1,
          index: index + 1
        })
      })
      // this.getPolygonPath()
      // console.log(this.polygonPath)
      await modifyFence({
        fenceId: this.fenceId,
        fenceType: this.editRegionFrom.fenceType,
        fencePointList: polygonPathpush
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.$t('operate.name85'))
        }
      }).catch(() => {})
    },
    // 百度
    async uploadPolygonPath () {
      this.polygonPathpush = JSON.parse(JSON.stringify(this.polygonPath))
      this.polygonPathpush.forEach((list, index) => {
        const bikepointbaidu = coordtransform.bd09togcj02(list.lng, list.lat)
        const bikepointsbaidu = coordtransform.gcj02towgs84(bikepointbaidu[0], bikepointbaidu[1])
        list.lng = Number(bikepointsbaidu[0])
        list.lat = Number(bikepointsbaidu[1])
      })
      // console.log('this.polygonPathpush====', this.polygonPathpush)
      // this.polygonPath.forEach((list, index) => {
      //   const bikepointbaidu = coordtransform.wgs84togcj02(list.lng, list.lat)
      //   const bikepointsbaidu = coordtransform.gcj02tobd09(bikepointbaidu[0], bikepointbaidu[1])
      //   list.lng = Number(bikepointsbaidu[0])
      //   list.lat = Number(bikepointsbaidu[1])
      // })
      // this.getPolygonPath()
      const polygonPathpush = []
      this.polygonPathpush.map((item, index) => {
        polygonPathpush.push({
          lat: item.lat,
          lng: item.lng,
          edit: item.edit,
          name: item.name,
          serialNo: index + 1,
          index: index + 1
        })
      })
      await modifyFence({
        fenceId: this.fenceId,
        fenceType: this.editRegionFrom.fenceType,
        fencePointList: polygonPathpush
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(this.$t('operate.name85'))
        }
      }).catch(() => {})
    },
    // 谷歌地图
    echoGraphical () {
      if (this.mapType === 'POLYGON') {
        // 回显多边形
        this.getgooglePolygonPath()
        this.graphicalPath = this.mapPath
        // const paths = JSON.parse(this.graphicalPath)
        const paths = this.graphicalPath
        // 存在就清除上一个图形
        if (this.graphicalExample) {
          this.graphicalExample.setMap(null)
        }
        if (this.markerBlack) {
          for (var i = 0; i < this.markerBlack.length; i++) {
            this.markerBlack[i].setMap(null)
          }
          this.markerBlack = []
        }
        // Construct a draggable red triangle with geodesic set to true.
        this.graphicalExample = new this.googleApi.maps.Polygon({
          paths,
          fillColor: 'blue',
          strokeColor: 'blue',
          strokeOpacity: 0.8,
          fillOpacity: 0.4,
          strokeWeight: 5,
          clickable: true,
          editable: true,
          zIndex: 1
        })
        if (this.mapPath.length > 0) {
          this.graphicalExample.setMap(this.googleMap)
          this.mapPath.forEach((list, index) => {
            const marker = new this.googleApi.maps.Marker({
              position: {
                lat: list.lat,
                lng: list.lng
              },
              icon: this.iconpointgoogle,
              title: this.$t('screen.name169') + (index + 1)
            })
            this.markerBlack.push(marker)
          })
          // 监听回显图形每一个路径点
          this.googleApi.maps.event.addListener(this.graphicalExample.getPath(), 'insert_at', (event) => {
            this.setPath(this.graphicalExample.getPath().Eg)
          })
          this.googleApi.maps.event.addListener(this.graphicalExample.getPath(), 'set_at', (event) => {
            this.setPath(this.graphicalExample.getPath().Eg)
          })
        }
        for (let i = 0; i < this.markerBlack.length; i++) {
          this.markerBlack[i].setMap(this.googleMap)
        }
      }
    },
    // path路径emit传出
    setPath (path) {
      this.graphicalPath = []
      if (path.length > 0) {
        path.forEach((v, index) => {
          this.graphicalPath.push({
            name: this.$t('screen.name169') + (index + 1),
            serialNo: index + 1,
            edit: false,
            index: index + 1,
            lat: v.lat(),
            lng: v.lng()
          })
        })
        this.mapPath = this.graphicalPath
        // this.polygonPathgoogle = this.graphicalPath
        // this.echoGraphical()
        // console.log(this.polygonPath)
        this.$emit('getGraphicalPath', this.mapPath)
        if (this.markerBlack) {
          for (var i = 0; i < this.markerBlack.length; i++) {
            this.markerBlack[i].setMap(null)
          }
          this.markerBlack = []
        }
        if (this.mapPath) {
          this.mapPath.forEach((list, index) => {
            const marker = new this.googleApi.maps.Marker({
              position: {
                lat: list.lat,
                lng: list.lng
              },
              icon: this.iconpointgoogle,
              title: this.$t('screen.name169') + (index + 1)
            })
            this.markerBlack.push(marker)
          })
        }
        for (let i = 0; i < this.markerBlack.length; i++) {
          this.markerBlack[i].setMap(this.googleMap)
        }
      }
    },
    // 移动标记点回调
    updateMaker (e) {
      this.longlat = e.latLng.lat() + ',' + e.latLng.lng()
      this.$emit('setLongLat', this.longlat)
    },
    // 添加可拖动的标记点
    addDraggableMarkers (max, draggable, {
      lat = 0,
      lng = 0
    }) {
      if (max !== -1) {
        this.marker.forEach((marker) => {
          marker.setMap(null)
        })
        this.marker = []
      }
      this.marker.push(
        new this.googleApi.maps.Marker({
          map: this.googleMap,
          position: {
            lat: lat,
            lng: lng
          },
          draggable: draggable
        })
      )
      if (draggable) {
        this.marker[0].addListener('dragend', (e) => {
          this.updateMaker(e)
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.bm-view {
  width: 100%;
  height: 500px;
  position: relative;
}
.serachinput{
  position: absolute;
  top: 15px;
  left: 15px;
  width: 30%;
}
</style>
